import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { ClientDetailScreen } from '@/features/clients/components/shared/ClientDetailScreen';

const searchSchema = z.object({
  tab: z
    .enum(['profile', 'history', 'red-flags', 'assessments', 'exercises', 'engagement', 'phi'])
    .catch('profile')
    .optional(),
});

export const Route = createFileRoute('/_staff/admin/workspace/clients/$clientId/')({
  component: WorkspaceClientDetailRoute,
  validateSearch: searchSchema.parse.bind(searchSchema),
});

function WorkspaceClientDetailRoute() {
  const { clientId } = useParams({ from: '/_staff/admin/workspace/clients/$clientId/' });
  return <ClientDetailScreen clientId={clientId} surface="workspace" />;
}
